import * as React from "react";
import { IErrorState } from "../reducers/appReducers";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";
import * as AppTypes from "AppTypes";

import "../components/serviceError.scss";

const Error: React.FC = () => {
  const { viewState = {} } = useSelector((store: AppTypes.ReducerState) => ({
    viewState: store.app.viewState as IErrorState,
  }));
  const { title, content } = viewState;

  return (
    <div className="content app-service-error">
      <div className="app-service-error__icon__unsupported"></div>
      <h2>{title || "Unsupported browser"}</h2>
      {
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(
              !!content
                ? content
                : "Upgrade to the latest version of Chrome or Safari on your device, and then try again"
            ),
          }}
        />
      }
    </div>
  );
};

export default Error;
